import { Component, OnInit } from '@angular/core';
import { FindOrderService } from "../service/find-order.service";
import { Router } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages/module";

@Component({
  selector: 'app-find-order',
  templateUrl: './find-order.component.html',
  styleUrls: ['./find-order.component.scss'],
  providers: [FindOrderService]
})
export class FindOrderComponent implements OnInit {

  private orderNumber;
  private order;

  constructor(private findorderservice: FindOrderService, private router: Router, private flashMessagesService: FlashMessagesService) { }

  ngOnInit() {

  }

  findOrder(){

    

    this.findorderservice.getOrderByID(this.pad(this.orderNumber,10)).subscribe(result => {
      console.log(result);
      if (result.Result) {
        console.log(result.Result);
        // this.router.navigateByUrl('conta-cliente/detalhe/'+result.Result.ClienteID);
        //There is no CLientID yet//
        this.order = result.Result;
			} else {
        this.flashMessagesService.show("Ordem de Venda não encontrada!", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
  }

	//add paddins with zeros to string number
  pad(num:number, size:number): string {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

}



// WEBPACK FOOTER //
// ./src/app/find-order/component/find-order.component.ts